<div class="PGCall {{stacked ? 'PGCall--Stacked' : ''}} {{hideInactive ? 'PGCall--HideInactive' : ''}}" #callContainer>
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading) {
        @for (participant of callParticipants; track participant) {
            <div class="PGCallParticipant {{participant.local ? 'PGCallParticipant--Local' : ''}} {{isFocused(participant) ? 'PGCallParticipant--Focus' : ''}} {{isInactive(participant) ? 'PGCallParticipant--Inactive' : ''}}">
                <div>
                    <app-pg-call-participant [participant]="participant"></app-pg-call-participant>
                </div>
            </div>
        }
    }
</div>